import { TutorialStep, PageTutorialConfig } from '../types';

// Header steps for public context
export const publicHeaderSteps: TutorialStep[] = [
  {
    target: '[data-onboarding="sidebar-trigger"]',
    title: "Menu latéral",
    message: "Ouvrez ou fermez le menu pour naviguer dans toutes les sections de l'application",
    position: "bottom-right"
  },
  {
    target: '[data-onboarding="home-button"]',
    title: "Accueil",
    message: "Retournez à la page d'accueil principale",
    position: "bottom"
  },
  {
    target: '[data-onboarding="back-button"]',
    title: "Retour",
    message: "Revenez à la page précédente, comme le bouton retour de votre navigateur",
    position: "bottom"
  },
  {
    target: '[data-onboarding="auth-button"]',
    title: "Connexion / Déconnexion",
    message: "Connectez-vous pour accéder à votre espace personnel",
    position: "bottom-left"
  },
  {
    target: '[data-onboarding="language-selector"]',
    title: "Langue",
    message: "Changez la langue de l'interface selon vos préférences",
    position: "bottom-left"
  },
  {
    target: '[data-onboarding="help-button"]',
    title: "Aide",
    message: "Cliquez ici à tout moment pour revoir ce tutoriel",
    position: "bottom-left"
  },
  // Sidebar steps
  {
    target: '[data-onboarding="sidebar-section-utilisateur"]',
    title: "Section Utilisateur",
    message: "Accédez à l'accueil, décrivez votre besoin ou devenez prestataire",
    position: "bottom-right"
  },
  {
    target: '[data-onboarding="sidebar-section-decouverte"]',
    title: "Découverte & Info",
    message: "Découvrez comment ça marche, la carte des prestataires, les tarifs et plus encore",
    position: "bottom-right"
  },
  {
    target: '[data-onboarding="sidebar-section-ressources"]',
    title: "Ressources",
    message: "Consultez la FAQ, le lexique et contactez-nous",
    position: "bottom-right"
  },
  {
    target: '[data-onboarding="sidebar-section-legal"]',
    title: "Documents Légaux",
    message: "Retrouvez les mentions légales, CGU, CGV et politiques de confidentialité",
    position: "bottom-right"
  }
];

// Page-specific tutorials for public pages
export const publicPageConfigs: PageTutorialConfig[] = [
  {
    routePattern: "/comment-ca-marche",
    exactMatch: true,
    steps: [
      {
        target: '[data-onboarding="ccm-steps"]',
        title: "Les étapes",
        message: "Découvrez les différentes étapes pour utiliser notre service, de la demande à la réalisation.",
        position: "bottom"
      }
    ]
  },
  {
    routePattern: "/tarifs",
    exactMatch: true,
    steps: [
      {
        target: '[data-onboarding="tarifs-grid"]',
        title: "Grille tarifaire",
        message: "Consultez nos tarifs transparents pour chaque type de service.",
        position: "bottom"
      }
    ]
  },
  {
    routePattern: "/carte",
    exactMatch: true,
    steps: [
      {
        target: '[data-onboarding="carte-map-card"]',
        title: "Carte interactive",
        message: "Explorez la carte pour visualiser la répartition des prestataires, clients et missions sur le territoire.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="carte-search-card"]',
        title: "Recherche géolocalisée",
        message: "Utilisez ce bloc pour rechercher des prestataires, villes ou médias près d'une position.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="carte-search-type"]',
        title: "Type de recherche",
        message: "Sélectionnez ce que vous cherchez : prestataires, villes avec missions, médias ou compétences.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="carte-search-query"]',
        title: "Recherche textuelle",
        message: "Tapez un nom, une ville ou un mot-clé pour filtrer les résultats.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="carte-search-location"]',
        title: "Position de recherche",
        message: "Entrez une adresse ou ville comme point de départ de votre recherche.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="carte-search-geoloc"]',
        title: "Géolocalisation",
        message: "Activez ce switch pour utiliser votre position actuelle automatiquement.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="carte-search-radius"]',
        title: "Rayon de recherche",
        message: "Définissez le rayon en kilomètres autour de votre position.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="carte-synthesis-card"]',
        title: "Synthèse du réseau",
        message: "Vue d'ensemble des statistiques : nombre de prestataires, clients, missions et villes couvertes.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="carte-synthesis-stats"]',
        title: "Filtres de visibilité",
        message: "Cliquez sur chaque bloc pour afficher/masquer les éléments correspondants sur la carte.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="carte-value-blocks"]',
        title: "Nos engagements",
        message: "Découvrez nos valeurs : couverture locale, prestataires qualifiés et données en temps réel.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="carte-cta-prestataire"]',
        title: "Devenir prestataire",
        message: "Cliquez ici pour rejoindre notre réseau de professionnels qualifiés.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="carte-cta-mission"]',
        title: "Décrire mon besoin",
        message: "Cliquez ici pour soumettre une demande et trouver un prestataire.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="carte-cta-tarifs"]',
        title: "Voir les tarifs",
        message: "Consultez notre grille tarifaire transparente.",
        position: "bottom-left"
      }
    ]
  },
  {
    routePattern: "/carte-prestataires",
    exactMatch: true,
    steps: [
      {
        target: '[data-onboarding="carte-map-card"]',
        title: "Carte interactive",
        message: "Explorez la carte pour trouver des prestataires près de chez vous.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="carte-search-card"]',
        title: "Recherche",
        message: "Affinez votre recherche par compétence, disponibilité ou zone géographique.",
        position: "bottom-left"
      }
    ]
  },
  {
    routePattern: "/deposer-mission",
    exactMatch: true,
    steps: [
      {
        target: '[data-onboarding="mission-form"]',
        title: "Formulaire de demande",
        message: "Décrivez votre besoin en détail pour recevoir des propositions adaptées.",
        position: "bottom"
      }
    ]
  },
  {
    routePattern: "/faq",
    exactMatch: true,
    steps: [
      {
        target: '[data-onboarding="faq-search"]',
        title: "Recherche",
        message: "Tapez un mot-clé pour trouver rapidement une réponse à votre question.",
        position: "bottom"
      },
      {
        target: '[data-onboarding="faq-categories"]',
        title: "Catégories",
        message: "Parcourez les questions par thème pour trouver l'information recherchée.",
        position: "bottom"
      }
    ]
  },
  {
    routePattern: "/lexique",
    exactMatch: true,
    steps: [
      {
        target: '[data-onboarding="lexique-search"]',
        title: "Recherche",
        message: "Recherchez un terme ou acronyme pour obtenir sa définition.",
        position: "bottom"
      }
    ]
  },
  {
    routePattern: "/contact",
    exactMatch: true,
    steps: [
      {
        target: '[data-onboarding="contact-form"]',
        title: "Formulaire de contact",
        message: "Envoyez-nous un message, nous vous répondrons dans les plus brefs délais.",
        position: "bottom"
      }
    ]
  },
  {
    routePattern: "/inscription-prestataire",
    exactMatch: true,
    steps: [
      {
        target: '[data-onboarding="inscription-form"]',
        title: "Formulaire d'inscription",
        message: "Remplissez ce formulaire pour devenir prestataire et recevoir des missions.",
        position: "bottom"
      }
    ]
  }
];
